import React from "react";
import { useEffect } from "react";
import "./CompletedInterviews.css";
import DatePicker from "react-date-picker";
import Navbarlogedin from "./Navbarlogedin";
import { Helmet } from "react-helmet";

import CompletedInterview from "./cards/CompletedInterview";

const changeLink = () => {
  const links = document.querySelectorAll(".nav-item a p");
  links.forEach((link) => {
    console.log(link.innerHTML);
    if (link.classList.contains("active")) {
      link.classList.remove("active");
    }
    if (link.innerHTML === 'Completed Interviews <div className="notify"></div>') {
      link.classList.add("active");
    }
  });
};

const CompletedInterviews = () => {
  useEffect(() => {
    changeLink();
  }, []);
  var prevScrollpos = window.pageYOffset;
  window.onscroll = function () {
    var currentScrollPos = window.pageYOffset;
    console.log(currentScrollPos);
    if (currentScrollPos >= 104) {
      document.querySelector("#head").style.position = "sticky";
      document.querySelector("#head").style.top = "0";
    } else {
      document.querySelector("#head").style.position = "unset";
      document.querySelector("#head").style.top = "0";
    }
    prevScrollpos = currentScrollPos;
  };
  const [date, setDate] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const [transition, setTransition] = React.useState(undefined);
  const handleClick = (Transition) => () => {
    setTransition(() => Transition);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Helmet>
        <title>Interwiu | Completed Interview</title>
        <meta name="description" content="Helmet application" />
      </Helmet>
      <Navbarlogedin />
      <div className="completed-interview interviews">
        <div className="inteviews-container"></div>
        <div className="flex justify-center items-center my-4" id="head">
          <h2 className="interview-head text-2xl font-medium">
            Completed Interviews (12)
          </h2>
        </div>
        <div className="interview-cont">
          <div className="flex justify-between mx-8">
            <div>
              Showing the results for {date ? date.toDateString() : "all days"}
            </div>
            <div className="flex gap-2">
              <label htmlFor="date">Filter by Date: </label>
              <DatePicker
                onChange={(newValue) => {
                  setDate(newValue);
                }}
                value={date}
              />
            </div>
          </div>
          <div className="interviews-list">
            <CompletedInterview />
            <CompletedInterview />
            <CompletedInterview />
          </div>
        </div>
      </div>
    </>
  );
};

export default CompletedInterviews;
